<template>
  <div class="asd-modal-overlay">
    <div class="asd-modal">
      <div class="asd-modal-title">
        <slot name="default"></slot>
      </div>
      <div class="asd-modal-controls">
        <slot name="controls"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import {  } from 'lodash'

export default {
    name: 'Modal',
}
</script>
